import { useContext, useEffect, useMemo } from "react";
import { Box, Link, Typography } from "@mui/material";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkTitle from "../../components/atoms/TkTitle";
import { TkRouteContext } from "../../context/tkRouteContext";
import { routes } from "../../routes/kikoSyokuinPagesDef";
import { manualList } from "./parts";
import "./_style.scss";

/**
 * SCRW020001_ヘルプ
 * @returns SCRW020001_ヘルプ
 */
const SCRW020001 = () => {
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const filterRouterList = useMemo(
    () =>
      routes
        .filter((item) => item.meta?.isMenuContent)
        .map((item) => item.path),
    []
  );

  // パンくずリストをクリアする
  useEffect(() => {
    if (!routerState.routerList?.find((item) => item.href === "/SCRW020001"))
      return;
    const filteredList = routerState.routerList.filter(
      (r) => filterRouterList.includes(r.href ?? "") || r.href === "/SCRW020001"
    );
    if (
      filteredList.length === routerState.routerList.length &&
      routerState.routerList.every((r, i) => r.href === filteredList[i].href)
    ) {
      return;
    }

    setRouterState({ routerList: filteredList });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routerState.routerList, setRouterState]);

  return (
    <Box className="SCRW020001">
      <TkInfoManual>{labelids.labelid.SCRW020001_01}</TkInfoManual>

      <Box className="field">
        {manualList.map((item, index) => (
          <Box key={index}>
            <TkTitle>■{item.title}</TkTitle>
            <TkInfoManual rule="\n">{item.index}</TkInfoManual>
            {item.detail && (
              <TkInfoManual rule="\n" className="detail">
                {item.detail}
              </TkInfoManual>
            )}
            <Box className="link">
              <Typography>{`>>`}</Typography>
              <Link
                href={`${process.env.PUBLIC_URL ?? ""}/assets/pdf/${item.link}`}
                target="_blank"
                rel="noreferrer"
              >
                {item.link}
              </Link>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SCRW020001;
